module.exports = __webpack_public_path__ + "static/media/fly0219.82e0b9d7.webp";